import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20cyberpunk%20cityscape%20at%20night%20with%20neon%20pink%20and%20cyan%20lights%20reflecting%20on%20wet%20streets%2C%20futuristic%20Chinese%20urban%20environment%2C%20massive%20holographic%20billboards%20displaying%20abstract%20data%20streams%2C%20deep%20atmospheric%20shadows%20with%20volumetric%20fog%2C%20cinematic%20wide-angle%20composition%2C%20highly%20detailed%20editorial%20photography%20style%2C%20moody%20noir%20atmosphere%20with%20electric%20color%20accents%20on%20dark%20background&width=1800&height=900&seq=hero-bg-2026-x1&orientation=landscape"
        alt="911爆料网 - 吃瓜黑料第一站"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/80"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-black/40"></div>

      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="lg:max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <div className="flex -space-x-2">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-accent-500 overflow-hidden bg-background-300">
                  <img
                    src="https://readdy.ai/api/search-image?query=Stylish%20young%20Asian%20person%20portrait%20with%20modern%20urban%20fashion%20style%2C%20neon%20lit%20circular%20headshot%20format%2C%20cyberpunk%20aesthetic%2C%20clean%20dark%20background%20with%20subtle%20rim%20lighting%2C%20editorial%20portrait%20photography&width=80&height=80&seq=hero-avatar-1&orientation=squarish"
                    alt="用户头像"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-accent-500 overflow-hidden bg-background-300">
                  <img
                    src="https://readdy.ai/api/search-image?query=Trendy%20young%20woman%20portrait%20with%20elegant%20street%20fashion%20look%2C%20soft%20neon%20pink%20rim%20lighting%20on%20dark%20background%2C%20circular%20headshot%20format%2C%20editorial%20portrait%20photography%20with%20moody%20atmosphere&width=80&height=80&seq=hero-avatar-2&orientation=squarish"
                    alt="用户头像"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-accent-500 overflow-hidden bg-background-300">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cool%20young%20Asian%20male%20portrait%20with%20casual%20streetwear%20style%2C%20moody%20cyan%20accent%20lighting%20on%20dark%20background%2C%20circular%20headshot%20format%2C%20editorial%20portrait%20photography%20with%20dramatic%20shadows&width=80&height=80&seq=hero-avatar-3&orientation=squarish"
                    alt="用户头像"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <span className="text-foreground-100 text-xs md:text-sm whitespace-nowrap">已有 2,890,000+ 吃瓜群众加入</span>
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold leading-tight mb-6">
              <span className="text-foreground-50">全网吃瓜</span>
              <br />
              <span className="text-primary-400">黑料第一站</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-200 max-w-lg mb-8 leading-relaxed">
              每日更新网红翻车、明星八卦、反差视频，最新大瓜一网打尽。免费无卡顿秒开，立即点击进入今日大瓜现场。
            </p>

            <button
              onClick={() => {
                const el = document.getElementById('daily-news');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-3 bg-foreground-50 text-background-50 px-6 py-3 rounded-full font-medium text-sm hover:bg-primary-500 hover:text-foreground-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <span className="w-7 h-7 rounded-full bg-background-50 flex items-center justify-center">
                <i className="ri-arrow-right-line text-foreground-50 text-sm"></i>
              </span>
            </button>
          </div>

          <div className="lg:max-w-sm">
            <p className="text-sm md:text-base text-foreground-200 leading-relaxed">
              汇聚全网最新最全的热门爆料，从网红翻车到明星八卦，从每日大赛到反差视频，让你的吃瓜速度快人一步
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}